import { render, staticRenderFns } from "./OnboardingWizardShell.vue?vue&type=template&id=0b635430&scoped=true"
import script from "./OnboardingWizardShell.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingWizardShell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OnboardingWizardShell.vue?vue&type=style&index=0&id=0b635430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b635430",
  null
  
)

export default component.exports